import { render } from "./SpecialLectureAdd.vue?vue&type=template&id=5453f226&scoped=true"
import script from "./SpecialLectureAdd.vue?vue&type=script&lang=js"
export * from "./SpecialLectureAdd.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./SpecialLectureAdd.vue?vue&type=style&index=1&id=5453f226&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5453f226"]])

export default __exports__